import { PaymentFormDataFields, PaymentFormValidationFields } from '../constants';
import { getPaymentFieldLabelText } from './getPaymentFieldLabelText';
import { getPaymentFieldErrorText } from './getPaymentFieldErrorText';
/**
 * Returns zipcode field configs (name , labelText, errors)
 * @param paymentForm Object of paymentFields and paymentErrors
 */
export var getZipFieldConfigs = function getZipFieldConfigs(paymentForm, paymentErrorModal, isUpi) {
  var zipLabelText = getPaymentFieldLabelText(isUpi ? PaymentFormDataFields.PINCODE : PaymentFormDataFields.ZIP_POSTAL, paymentForm);
  // zipcode require error validations
  var requiredError = getPaymentFieldErrorText({
    paymentForm: paymentForm,
    paymentErrorModal: paymentErrorModal,
    error: isUpi ? PaymentFormDataFields.REQUIRED_PINCODE : PaymentFormDataFields.REQUIRED_ZIP_POSTAL,
    requiredKey: isUpi ? PaymentFormValidationFields.REQUIRED_PINCODE : PaymentFormValidationFields.REQUIRED_ZIP_POSTAL,
    invalidKey: isUpi ? PaymentFormValidationFields.INVALID_PINCODE : PaymentFormValidationFields.INVALID_ZIP_POSTAL
  });

  // zipcode invalid error validations
  var invalidError = getPaymentFieldErrorText({
    paymentForm: paymentForm,
    paymentErrorModal: paymentErrorModal,
    error: isUpi ? PaymentFormDataFields.INVALID_PINCODE : PaymentFormDataFields.INVALID_ZIP_POSTAL,
    requiredKey: isUpi ? PaymentFormValidationFields.REQUIRED_PINCODE : PaymentFormValidationFields.REQUIRED_ZIP_POSTAL,
    invalidKey: isUpi ? PaymentFormValidationFields.INVALID_PINCODE : PaymentFormValidationFields.INVALID_ZIP_POSTAL
  });
  return {
    name: 'zipPostal',
    labelText: zipLabelText,
    errors: {
      required: requiredError,
      invalid: invalidError
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UserAddress/utils/getZipFieldConfigs.js
// module id = 4551
// module chunks = 11